import * as z from "zod";
import { Id } from "./ids.js";

/** How far back a "today" count may reach, so a client clock cannot turn it into a full scan. */
export const SHELL_STATS_MAX_LOOKBACK_MS = 48 * 60 * 60 * 1000;

export const BotTodayStatsInput = z.object({
  botId: Id,
  /** Start of the viewer's local day. Older values are clamped to `SHELL_STATS_MAX_LOOKBACK_MS`. */
  since: z.iso.datetime({ offset: true }),
});
export type BotTodayStatsInput = z.infer<typeof BotTodayStatsInput>;

export const BotTodayStatsSchema = z.object({
  /** Tool calls the bot made since `since`. */
  toolCalls: z.number().int().nonnegative(),
  /** The bot's runs waiting on the caller: a question, an approval, or taking over its computer. */
  needsYou: z.number().int().nonnegative(),
});
export type BotTodayStats = z.infer<typeof BotTodayStatsSchema>;

export const SpaceNeedsYouSchema = z.object({
  spaceId: Id,
  needsYou: z.number().int().nonnegative(),
});
export type SpaceNeedsYou = z.infer<typeof SpaceNeedsYouSchema>;
